import { render } from "./ArtistItem.vue?vue&type=template&id=684ac67c"
import script from "./ArtistItem.vue?vue&type=script&lang=js"
export * from "./ArtistItem.vue?vue&type=script&lang=js"

import "./ArtistItem.vue?vue&type=style&index=0&id=684ac67c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__